module.exports = __webpack_public_path__ + "img/28.37abb25e.jpg";